import { type Component, type JSX } from 'solid-js'
import { Icon } from '@iconify-icon/solid'
import { getValueColorByKPI } from '../../../shared/helpers/get-value-color'
import { type NumericalDataType } from '../../../shared/models/numerical-data-type'
import { type DiffType, KPIDiffType, type KPIType } from '../../../features/analytics/domain/models/kpi'
import { useNumberFormatter } from '../../../shared/helpers/currency-formatter'

export interface ProgressRatioProps {
  readonly value: number | undefined
  readonly prevValue?: number
  readonly type?: NumericalDataType
  readonly kpi?: KPIType
}

const ProgressRatio: Component<ProgressRatioProps> = (props) => {
  const { percentageFormatter } = useNumberFormatter()

  const icon = (): JSX.Element => {
    const value = props.value
    if (value === undefined) {
      return <Icon icon="heroicons:minus-small-20-solid" class="text-[1rem]" />
    }

    return value > 0 ? (
      <Icon icon="heroicons:arrow-small-up-20-solid" class="text-[1rem]" />
    ) : value === 0 ? (
      <Icon icon="heroicons:minus-small-20-solid" class="text-[1rem]" />
    ) : (
      <Icon icon="heroicons:arrow-small-down-20-solid" class="text-[1rem]" />
    )
  }

  const kpiType = (): DiffType | undefined => (props.kpi ? KPIDiffType[props.kpi] : undefined)

  return (
    <div class="flex relative h-6 items-center min-w-[58px]">
      <span
        class={
          `${getValueColorByKPI(props.value, kpiType())}` +
          ' font-semibold inline-flex items-center text-sm cursor-default'
        }
      >
        {icon()} {percentageFormatter(props.value)}
      </span>
    </div>
  )
}

export default ProgressRatio
